export default __webpack_public_path__ + "static/media/SuperChat.ca35185e.jpeg";